<template>
  <div class="coach-rank">
    <div class="rank-flex">
      <div class="rank-scroll" :class="{ 'rank-scroll-disabled': !scroll }">
        <CoachRank
          v-if="activityInfo"
          :data="rankList"
          @dynamic="bindToDynamic"
          :isMember="activityInfo.activity_crowd == 1"
        ></CoachRank>
      </div>
    </div>
  </div>
</template>

<script>
import CoachRank from './coach-rank.vue'
export default {
  components: { CoachRank },
  props: {
    storeId: {
      type: [String, Number, undefined],
      default: undefined
    },
    scroll: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      activityInfo: null,
      rankList: null
    }
  },
  created() {
    this.getData()
  },
  computed: {},
  methods: {
    async getData() {
      let params = {
        is_disclosure: this.$betterwe.isApp() ? 0 : 1 //是否公开
      }
      let res = await this.$http
        .getAppWithAppInfo('api/v1/AnnualCoach/initActivity', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.activityInfo = res.data
        }
      }
      let res1 = await this.$http
        .getApp('api/v1/AnnualCoach/coachRank', { store_id: this.storeId })
        .catch(() => {})
      if (res1) {
        res1 = res1.data
        if (res1.code == 200) {
          this.rankList = res1.data
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.coach-rank {
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  .find-more {
    padding: 30px 20px 0px;
    font-weight: bold;
    font-size: 14px;
    color: #050b27;
    line-height: 20px;
    margin-bottom: 7px;
    display: flex;
    align-items: center;
    .iconfont {
      font-weight: normal;
      color: rgba(5, 11, 39, 0.3);
      margin-right: 3px;
    }
    .line {
      width: 1px;
      height: 11px;
      background-color: rgba(5, 11, 39, 0.5);
      margin: 0px 5px;
    }
    .change-store {
      font-weight: normal;
      font-size: 12px;
      color: rgba(5, 11, 39, 0.5);
      line-height: 17px;
    }
  }
  .rank-flex {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    .rank-scroll {
      height: 100%;
      overflow-y: scroll;
    }
    .rank-scroll-disabled {
      overflow-y: hidden;
    }
  }
}
</style>
